import styled from "@emotion/styled"

export default styled.div`
  display: flex;
  align-items: center;
  max-width: 1040px;
  margin: 0 auto;
  padding: 0 20px;
`
